import { render, staticRenderFns } from "./CollapseItem1.vue?vue&type=template&id=06c2ec8e"
import script from "./CollapseItem1.vue?vue&type=script&lang=js"
export * from "./CollapseItem1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports